import { AxiosResponse } from "axios";
import * as Yup from "yup";
import { meterSchema } from "../schemas/meter.schema";
import Cookies from "js-cookie";
import { DEFAULT_PAGE_LIMIT, endpoints } from "../constants/api";
import { $http } from "../config/axiosConfig";

export const createMeterAsync = async ({
  values,
}: {
  values: Yup.InferType<typeof meterSchema>;
}) => {
  const isValidFields = await meterSchema.isValid(values);

  if (isValidFields) {
    const token = Cookies.get("token");

    const payload = {
      meterSerialNo: values.meterNumber,
      MSISDN: String(values.msisdn),
      ICCID: String(values.iccid),
      EXP_year: values.expiry,
      model: values.model,
      Property_tbl_id: values.propertyId,
      More_details: values.moreDetails,
      tariff: values.tariff,
      location: `${values.latitude},${values.longitude}`,
      wra: values.wra,
    };

    try {
      const data: AxiosResponse = await $http.post(
        endpoints.addMeter,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return { data: data?.data };
    } catch (error) {
      return error;
    }
  } else {
    return new Response("Invalid fields!", { status: 400 });
  }
  
};

export const fetchDailyConsumptionAsync = async (entryId: number) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.meterDailyConsumption}/${entryId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchWeeklyConsumptionAsync = async (meterId: string) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.meterWeeklyConsumption}/${meterId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchPropertyMetersAsync = async (propertyId: string) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.meters}/${propertyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchMeterPayloadDetailsAsync = async (id: string) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.payloadDetails}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchDailyCutoffsAsync = async (
  meterNum: string,
  page = 1,
  limit = DEFAULT_PAGE_LIMIT
) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.dailyCutoffs}/${meterNum}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchMonthlyCutoffsAsync = async (
  meterNum: string,
  page = 1,
  limit = DEFAULT_PAGE_LIMIT
) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.monthlyCutoffs}/${meterNum}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const fetchMeterPublicInfoAsync = async (meterSerialNo: string) => {
  const data: AxiosResponse = await $http.get(
    `${endpoints.meterPublicInfo}/${meterSerialNo}`
  );
  return data?.data;
};

export const fetchMeterDeviceInfoAsync = async (meterSerialNo: string) => {
  const data: AxiosResponse = await $http.get(
    `${endpoints.meterDeviceInfo}/${meterSerialNo}`
  );
  return data?.data;
};

export const fetchMeterDetailsAsync = async (meterSerialNo: string) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.meterDetails}/${meterSerialNo}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};
